import { render, staticRenderFns } from "./ai-chat.vue?vue&type=template&id=5348f508"
import script from "./ai-chat.vue?vue&type=script&lang=js"
export * from "./ai-chat.vue?vue&type=script&lang=js"
import style0 from "./ai-chat.vue?vue&type=style&index=0&id=5348f508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports